import { isEven } from '../libs/math'

const getIndexWithKey = (array: any[], itemKey: any, checkFor: any) =>
  array.length > 0
    ? array.findIndex((arrayItem) => arrayItem[itemKey] === checkFor)
    : -1

const findValueWithComparisonFunc = (array: any[], comparisonFunc: any) =>
  array.length > 0
    ? array.find((arrayItem) => comparisonFunc(arrayItem))
    : undefined

const getIndex = (array: any[], checkFor: any) =>
  array.length > 0 ? array.findIndex((arrayItem) => arrayItem === checkFor) : -1

export type ValueOfFlattened<T> = {
  0: T
  1: T extends Array<infer U> ? ValueOfFlattened<U> : never
}[T extends Array<unknown> ? 1 : 0]

export type ValuerOrArray<T> = T | Array<ValuerOrArray<T>>

const getFlatArray = function <ReturnType>(
  arr: Array<ValuerOrArray<ReturnType>>,
  result = [] as ReturnType[]
): ReturnType[] {
  for (let i = 0, length = arr.length; i < length; i++) {
    const value = arr[i]
    if (Array.isArray(value)) {
      getFlatArray(value, result)
    } else {
      result.push(value)
    }
  }
  return result
}

const getSelectedFromArray = (array: any[] | undefined, index: number) => {
  if (index > -1 && array && array[index]) {
    return array[index]
  } else {
    return []
  }
}

// if value is found in array, return true
const valueExistsInArray = (array: any[], value: any) =>
  getIndex(array, value) !== -1

const findItemWithKey = (array: any[], key: any) =>
  array.find((item) => item.key === key)

const returnEven = (array: any[]) => {
  let evenArray: any[] = []
  array.forEach((item: any, index: number) => {
    if (isEven(index)) {
      evenArray = [...evenArray, item]
    }
  })
  return evenArray
}

const afterHalfPoint = (array: any[], index: number) =>
  index + 1 > Math.round(array.length / 2)

const removeEmptyItems = (array: any[]) =>
  array.filter((item) => item !== null && item !== undefined)

export {
  getIndex,
  findValueWithComparisonFunc,
  getIndexWithKey,
  getFlatArray,
  getSelectedFromArray,
  valueExistsInArray,
  findItemWithKey,
  returnEven,
  afterHalfPoint,
  removeEmptyItems
}
